import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Auth/ForgotPassword/ForgotPassword.tsx");
